import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationLocationItamsConstants {
    static STEP_TITLE = "Location";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static LAYER_REF = "ITAMS graphics";
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
    static PROPERTIES_FORM_GROUP_NAME = "propertiesForm";
    static ERF_NO_CONTROL = "erfNo";
    static ERF_SIZE_CONTROL = "erfSize";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static BAY_NUMBER_CONTROL = "bayNumber";
    static BAY_SIZE_CONTROL = "baySize";
    static GEOMETRY_CONTROL = "geometry";
    static CENTROID_CONTROL = "centroid";
    static PROPERTIES_CONTROL = "properties";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static BAY_NUMBER_PLACEHOLDER = "Bay number";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size";
    static BAY_SIZE_TEXT_PLACEHOLDER = "Bay size";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, bayNumber: {
            required: `Bay number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, baySize: {
            required: `Bay size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
